'use client';

import { useMemo } from 'react';
import { BigNum, PRICE_PRECISION_EXP } from '@velocity-exchange/sdk';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { BalanceRowData } from './types';
import { cm } from 'src/utils/classNames';
import { PRESETS } from 'src/utils/formatNumber/presets';

interface LiqPriceCellProps {
	row: BalanceRowData;
}

export function LiqPriceCell({ row }: LiqPriceCellProps) {
	const { spotMarketIndex } = row;

	const currentUserClient = useVelocityAccountStore(
		(s) => s.getCurrentUserAccount()?.client
	);

	const liqPrice = useMemo(() => {
		const liquidationPrice =
			currentUserClient?.spotLiquidationPrice(spotMarketIndex);
		return BigNum.from(liquidationPrice ?? 0, PRICE_PRECISION_EXP);
	}, [currentUserClient, spotMarketIndex]);

	const isValid = liqPrice.gtZero();

	return (
		<div className={cm('flex items-center', !isValid && 'text-text-disabled')}>
			<NumberDisplay
				value={liqPrice}
				options={PRESETS.usd}
				displayOverride={isValid ? undefined : '-'}
				isAccountValueToHide
			/>
		</div>
	);
}
